const sizes = [
  {
    value: "47",
    mm: "15,25MM"
  },
  {
    value: "48",
    mm: "15,25MM"
  },
  {
    value: "49",
    mm: "15,25MM"
  },
  {
    value: "50",
    mm: "15,25MM"
  },
  {
    value: "51",
    mm: "15,25MM"
  },
  {
    value: "52",
    mm: "15,25MM"
  },
  {
    value: "53",
    mm: "15,25MM"
  },
  {
    value: "54",
    mm: "15,25MM"
  },
  {
    value: "55",
    mm: "15,25MM"
  },
  {
    value: "56",
    mm: "15,25MM"
  },
  {
    value: "57",
    mm: "15,25MM"
  },
  {
    value: "58",
    mm: "15,25MM"
  },
  {
    value: "59",
    mm: "15,25MM"
  },
  {
    value: "60",
    mm: "15,25MM"
  },
  {
    value: "61",
    mm: "15,25MM"
  },
  {
    value: "62",
    mm: "15,25MM"
  },
  {
    value: "63",
    mm: "15,25MM"
  },
  {
    value: "64",
    mm: "15,25MM"
  },
  {
    value: "65",
    mm: "15,25MM"
  },
  {
    value: "66",
    mm: "15,25MM"
  },
  {
    value: "67",
    mm: "15,25MM"
  },
  {
    value: "102",
    mm: "15,25MM"
  },
  {
    value: "106",
    mm: "15,25MM"
  },
  {
    value: "110",
    mm: "15,25MM"
  },
  {
    value: "114",
    mm: "15,25MM"
  },
  {
    value: "118",
    mm: "15,25MM"
  },
  {
    value: "24",
    mm: "15,25MM"
  },
  {
    value: "25",
    mm: "15,25MM"
  },
  {
    value: "26",
    mm: "15,25MM"
  },
  {
    value: "27",
    mm: "15,25MM"
  },
  {
    value: "90",
    mm: "15,25MM"
  },
  {
    value: "94",
    mm: "15,25MM"
  },
  {
    value: "98",
    mm: "15,25MM"
  },
  {
    value: "28",
    mm: "15,25MM"
  },
  {
    value: "29",
    mm: "15,25MM"
  },
  {
    value: "30",
    mm: "15,25MM"
  },
  {
    value: "31",
    mm: "15,25MM"
  },
  {
    value: "32",
    mm: "15,25MM"
  },
  {
    value: "33",
    mm: "15,25MM"
  },
  {
    value: "46",
    mm: "15,25MM"
  },
  {
    value: "42",
    mm: "15,25MM"
  },
  {
    value: "44",
    mm: "15,25MM"
  }
];
